export enum UserAvatarSize {
  Workspace = -1,
  CustomLayout = 46,
  Profile = 200,
  Header = 24,
  Table = 24,
  Comment = 32,
  Tasks = 32,
  Analytics = 40,
  Feed = 34,
  Notification = 34,
  Posts = 48,
  Card = 48,
  RankingFirst = 130,
  RankingOthers = 92,
  Ranking = 28,
  SmallCard = 16,
  Copilot = 32,
}

export interface ISvzUserAvatar {
  name: string;
  picture?: string | null;
  pictureHQ?: string | null;
  size: UserAvatarSize;
  initialsColor?: string | null;
  type?: 1 | 2 | 3;
  initialsFontSize?: number;
  initialsTextColor?: string | null;
  showBorder?: boolean;
}
